import { useTranslation } from '@framework/i18n';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
const image = {
  url: require('../../images/Mic-numero-verde-Amministrazione-Trasparente.svg'),
};

const StyledLogoImg = styled.img`
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;

  border: none;
  margin: 0;
  padding: 0;
`;

const LogoWrapper = styled.div`
  width: 200px;
  max-width: 100%;
  height: auto;

  ${down('sm')} {
    width: 120px;
  }
`;
export interface IFrontFooterNumeroVerdeProps {}

/**
 * Numero verde MiC.
 */
export function FrontFooterNumeroVerde(props: IFrontFooterNumeroVerdeProps) {
  const { t } = useTranslation();

  return (
    <LogoWrapper>
      <StyledLogoImg
        src={image.url}
        alt={t(
          'front-footer-numero-verde.alt',
          'Numero Verde Gratuito 800 991199 Amministrazione Trasparente | Ministero della Cultura',
        )}
      />
    </LogoWrapper>
  );
}
